/** CheckBox registration: the parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseCheckBox } from './parser';
const checkBoxRegistration = {
    typeName: 'CheckBox',
    parser: parseCheckBox,
};
nodeRegistry.register(checkBoxRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map